/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/terms/team-leader.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core

// App components
import { Link } from '@client/components';
import Page from '@/client/pages/_layout/_page';

/*----------------------------------
- TABS
----------------------------------*/
const TermsTabs = ({
  current
}: {
  current: 'tools' | 'marketplace' | 'csm' | 'teamLeader' | 'businessPartner' | 'dealPartner' | 'ambassadors';
}) => {
  const base = 'px-4 py-2 rounded-lg text-sm font-semibold transition-colors';
  const active = 'bg-gradient-to-r from-orange-500 to-pink-500 text-white shadow';
  const inactive = 'text-slate-700 hover:text-orange-600 hover:bg-orange-50';
  return <div className="flex flex-wrap items-center gap-2 bg-orange-50 border border-orange-100 rounded-xl p-2">
            <Link to="/terms" className={`${base} ${current === 'tools' ? active : inactive}`}>
                Tools
            </Link>
            <Link to="/terms/marketplace" className={`${base} ${current === 'marketplace' ? active : inactive}`}>
                Marketplace
            </Link>
            <Link to="/terms/csm" className={`${base} ${current === 'csm' ? active : inactive}`}>
                CSM
            </Link>
            <Link to="/terms/team-leader" className={`${base} ${current === 'teamLeader' ? active : inactive}`}>
                Team Leader
            </Link>
            <Link to="/terms/business-partner" className={`${base} ${current === 'businessPartner' ? active : inactive}`}>
                Business Partner
            </Link>
            <Link to="/terms/deal-partner" className={`${base} ${current === 'dealPartner' ? active : inactive}`}>
                Deal Partner
            </Link>
            <Link to="/terms/ambassadors" className={`${base} ${current === 'ambassadors' ? active : inactive}`}>
                Ambassadors
            </Link>
        </div>;
};

/*----------------------------------
- PAGE: TEAM LEADER TERMS
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/terms/team-leader', { ...({
  static: {
    refresh: '1h',
    urls: ['/terms/team-leader']
  }
}), ...{ filepath: "/app/client/pages/terms/team-leader.tsx", sourceLocation: { line: 54, column: 1 }, id: "terms_team_leader" } }, null, ({}) => {
  const placeholderClassName = 'font-bold text-slate-900';
  return <Page mainClassName="pt-28 pb-20 px-6 lg:px-8 bg-gradient-to-br from-orange-50 via-white to-pink-50">
            <div className="max-w-[920px] mx-auto">
                <div className="mb-6">
                    <TermsTabs current="teamLeader" />
                </div>

                <div className="bg-white rounded-2xl shadow-lg border border-orange-100 p-8 md:p-10">
                    <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent mb-6">
                        Team Leader Agreement
                    </h1>

                    <div className="prose prose-slate max-w-none">
                        <header className="mb-6">
                            <p className="text-slate-700 mb-0">
                                This Team Leader Agreement (hereinafter referred to as the “Agreement”) is entered into
                                as of <span className={placeholderClassName}>[DATE]</span>, between:
                            </p>
                        </header>

                        <section className="not-prose border border-slate-200 rounded-xl p-4 bg-slate-50 mb-8" aria-label="Parties">
                            <dl className="text-slate-800">
                                <dt className="font-bold mt-0">Cross Path Network Ltd</dt>
                                <dd className="ml-0 mt-1">Registered in England with registration number 13863925</dd>
                                <dd className="ml-0 mt-1">
                                    Address: Unit 01.12, 1st Floor, 30 Norman Road, London, SE10 9QX, United Kingdom
                                </dd>
                                <dd className="ml-0 mt-1">(“Cross Path” or the “Company”)</dd>

                                <dt className="font-bold mt-4">Team Leader</dt>
                                <dd className="ml-0 mt-1">
                                    Name of the Team Leader: <span className={placeholderClassName}>[NAME]</span>
                                </dd>
                                <dd className="ml-0 mt-1">
                                    Address of the Team Leader: <span className={placeholderClassName}>[ADDRESS]</span>
                                </dd>
                                <dd className="ml-0 mt-1">(“Team Leader”)</dd>
                            </dl>
                            <p className="text-slate-600 mt-3 mb-0">Collectively referred to as “the Parties”.</p>
                        </section>

                        <section className="mt-0">
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                1. Purpose of the Agreement
                            </h2>
                            <p className="text-slate-700 mb-0">
                                The purpose of this Agreement is to define the terms and conditions under which the Team
                                Leader operates as an affiliated independent recruiter and team manager using Cross
                                Path&apos;s infrastructure, tools, and methodology to sign recruitment mandates with
                                clients and to build and manage a team of Business Partners.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                2. Nature of the Collaboration
                            </h2>
                            <p className="text-slate-700 mb-4">
                                The relationship established by this Agreement is that of independent contractors.
                                Nothing in this Agreement shall be construed to create a relationship of employer and
                                employee, principal and agent, or joint venture between the Parties.
                            </p>
                            <p className="text-slate-700 mb-0">
                                The Team Leader is affiliated with Cross Path and may present themselves as such.
                                However, all client contracts are signed between Cross Path Network Ltd and the client,
                                with the Team Leader listed as the client relationship manager.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                3. Responsibilities of the Team Leader
                            </h2>
                            <p className="text-slate-700 mb-4">The Team Leader agrees to:</p>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">3.1 Business Development</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Conduct business development activities using Cross Path&apos;s methodology,
                                    including building a network of deal partners, or any other method of their
                                    choosing.
                                </li>
                                <li>
                                    Integrate Deal Partners into the platform by providing them with restricted free
                                    access to the CRM, enabling them to create and track their own leads.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">3.2 Client Contracting</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Generate recruitment contracts with clients using Cross Path&apos;s contract
                                    templates and commercial scoping tools.
                                </li>
                                <li>
                                    Sign recruitment mandates with clients as a representative of Cross Path Network Ltd
                                    (acting as Cross Path&apos;s mandatary).
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                3.3 Sourcing and Recruitment Execution
                            </h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Decide independently whether to conduct candidate sourcing themselves or delegate
                                    sourcing to:
                                </li>
                                <li>Cross Path&apos;s network of free recruiters;</li>
                                <li>Team members;</li>
                                <li>External sourcers; or</li>
                                <li>Any combination thereof.</li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">3.4 Team Management</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Recruit, onboard, and manage Business Partners within their team using Cross
                                    Path&apos;s team management tools.
                                </li>
                                <li>Provide training, support, and guidance to team members.</li>
                                <li>Monitor team performance and activity through the team dashboard.</li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">3.5 Commission Distribution</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Decide on the commission split distribution among all parties involved in each
                                    mission after Cross Path&apos;s retained share, including team members, deal
                                    partners, CSMs, sourcers, or other contributors, at their sole discretion.
                                </li>
                                <li>
                                    Determine whether to allocate themselves a management commission on deals closed by
                                    their team members.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">3.6 Platform and Tools Usage</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Use Cross Path&apos;s tools and platform subject to the applicable access terms.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">3.7 Professional Conduct</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-0">
                                <li>
                                    Maintain professionalism and integrity when presenting Cross Path&apos;s services.
                                </li>
                                <li>Comply with all applicable anti-bribery and anti-corruption laws.</li>
                                <li>
                                    Not make any commitments, statements, or representations on behalf of Cross Path
                                    without prior written approval.
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                4. Responsibilities of Cross Path
                            </h2>
                            <p className="text-slate-700 mb-4">Cross Path agrees to:</p>
                            <ul className="list-disc pl-6 text-slate-700 mb-0">
                                <li>
                                    Provide access to its recruitment tools, CRM, ATS, and business development platform
                                    subject to the applicable access terms.
                                </li>
                                <li>
                                    Provide team management tools, including custom registration links and team
                                    dashboards.
                                </li>
                                <li>Provide contract templates, commercial scoping tools, and operational support.</li>
                                <li>
                                    Provide restricted CRM access for Deal Partners onboarded by the Team Leader (at no
                                    cost to the Deal Partners).
                                </li>
                                <li>Be the signing and invoicing party for all client contracts.</li>
                                <li>Handle payment collection from clients.</li>
                                <li>
                                    Calculate and distribute commissions in accordance with the terms specified in each
                                    recruitment mandate.
                                </li>
                                <li>
                                    Calculate and distribute recurring program revenue sharing to the Team Leader for
                                    their recruited team members.
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                5. Commission and Payment Terms
                            </h2>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">5.1 Placement Commissions</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Cross Path shall retain the commercial share specified in each individual
                                    recruitment contract signed with the client.
                                </li>
                                <li>
                                    The remaining share shall be allocated by the Team Leader among all parties involved
                                    in the mission (including themselves, team members, any deal partners, CSMs,
                                    sourcers, etc.) at their sole discretion.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">5.2 Recurring Program Revenue</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    The Team Leader shall be entitled to the recurring program revenue share specified
                                    in their separate agreement for recruited Business Partners or Team Recruiters who
                                    remain active.
                                </li>
                                <li>
                                    This revenue sharing applies to eligible Business Partner, Team Recruiter, and Team
                                    Leader relationships.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">5.3 Payment Conditions</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-0">
                                <li>
                                    Commission payments will be made only after Cross Path has received the full amount
                                    due from the client, and provided no portion of that amount is subject to refund or
                                    reimbursement.
                                </li>
                                <li>
                                    The Team Leader acknowledges that no commission shall be payable for any mandate
                                    that does not result in a successful paid placement.
                                </li>
                                <li>
                                    Recurring program revenue will be calculated and paid monthly based on active
                                    relationships.
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                6. Platform Access Terms
                            </h2>
                            <p className="text-slate-700 mb-0">
                                The Team Leader&apos;s access to the platform, tools, and team management features is
                                governed by the commercial terms agreed separately and may be modified by Cross Path
                                with 30 days&apos; prior written notice.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                7. Confidentiality
                            </h2>
                            <p className="text-slate-700 mb-4">
                                7.1 The Parties agree to keep all confidential information obtained during the course of
                                this Agreement strictly confidential and not to disclose it to any third party during or
                                after the term of this Agreement.
                            </p>
                            <p className="text-slate-700 mb-0">
                                7.2 These confidentiality obligations shall survive the termination of this Agreement
                                indefinitely for as long as the Confidential Information remains non-public or
                                proprietary in nature.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                8. Duration and Termination
                            </h2>
                            <p className="text-slate-700 mb-2">
                                This Agreement shall remain in effect until terminated by either Party.
                            </p>
                            <p className="text-slate-700 mb-2">
                                Either Party may terminate this Agreement at any time by providing written notice to the
                                other Party.
                            </p>
                            <p className="text-slate-700 mb-2">
                                Any commissions accrued prior to termination shall remain payable in accordance with the
                                conditions set forth in Section 5. “Accrued” means that all conditions necessary for
                                payment have been satisfied.
                            </p>
                            <p className="text-slate-700 mb-0">
                                Upon termination, the Team Leader&apos;s entitlement to recurring SaaS revenue from
                                their team members shall cease.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                9. Governing Law and Jurisdiction
                            </h2>
                            <p className="text-slate-700 mb-4">
                                This Agreement and any dispute, claim, or obligation arising out of or in connection
                                with it shall be governed by and construed in accordance with English law.
                            </p>
                            <p className="text-slate-700 mb-0">
                                The Parties irrevocably agree to submit to the exclusive jurisdiction of the English
                                courts.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                10. Miscellaneous
                            </h2>
                            <p className="text-slate-700 mb-4">
                                The Team Leader must promptly report to Cross Path any improper request or activity that
                                could constitute bribery or corruption.
                            </p>
                            <p className="text-slate-700 mb-4">
                                Any amendment or modification to this Agreement must be made in writing and signed by
                                both Parties.
                            </p>
                            <p className="text-slate-700 mb-0">
                                IN WITNESS WHEREOF, the Parties have executed this Agreement as of the date first
                                written above.
                            </p>
                        </section>

                        {/* Signatures removed */}
                    </div>
                </div>
            </div>
        </Page>;
});
};
